// Correct initialization
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDcNCZs0EaC6zJ3fpz38PgK2vvYWg3FvE8",
  authDomain: "mvsitgiants-fa73a.firebaseapp.com",
  projectId: "mvsitgiants-fa73a",
  storageBucket: "mvsitgiants-fa73a.firebasestorage.app",
  messagingSenderId: "558096847913",
  appId: "1:558096847913:web:5ec682ca20173d0af63838",
  measurementId: "G-JGN5610VYC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
